import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const langPrefixes = { en: '', zh: '/zh', ko: '/ko' };

function Navbar({ t, lang, setLang }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const prefix = langPrefixes[lang] || '';

  const navLinks = [
    { to: `${prefix}/`, label: t.nav.home },
    { to: `${prefix}/erotic-massage-sukhumvit`, label: t.nav.erotic },
    { to: `${prefix}/nuru-massage-sukhumvit`, label: t.nav.nuru },
    { to: `${prefix}/contact`, label: t.nav.contact },
  ];

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'zh', label: '中文' },
    { code: 'ko', label: '한국어' },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLogoClick = (e) => {
    if (location.pathname === `${prefix}/` || location.pathname === prefix) {
      e.preventDefault();
      scrollToTop();
    }
  };

  const handleLangChange = (code) => {
    setLang(code);
    setLangOpen(false);
    const currentPath = location.pathname;
    const basePath = currentPath.replace(/^\/(en|zh|ko)/, '') || '/';
    const newPrefix = langPrefixes[code] || '';
    navigate(`${newPrefix}${basePath === '/' ? '/' : basePath}`);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-dark/95 backdrop-blur-md border-b border-gold/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to={`${prefix}/`} onClick={handleLogoClick} className="flex items-center">
            <img src="/logo.png" alt="Bunny Boy Massage" className="h-10 w-auto" />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm font-montserrat tracking-widest uppercase text-white/80 hover:text-gold transition-colors duration-300"
              >
                {link.label}
              </Link>
            ))}

            <div className="relative">
              <button
                onClick={() => setLangOpen(!langOpen)}
                className="text-sm font-montserrat tracking-widest uppercase text-gold border border-gold/30 px-4 py-2 hover:bg-gold/10 transition-all duration-300"
              >
                {t.nav.lang}
              </button>
              {langOpen && (
                <div className="absolute right-0 mt-2 w-32 bg-dark-secondary border border-gold/30 shadow-xl">
                  {languages.map((l) => (
                    <button
                      key={l.code}
                      onClick={() => handleLangChange(l.code)}
                      className={`block w-full text-left px-4 py-3 text-sm hover:bg-gold/10 transition-colors ${
                        lang === l.code ? 'text-gold' : 'text-white/80'
                      }`}
                    >
                      {l.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <a
              href="#contact"
              className="text-sm font-montserrat tracking-widest uppercase bg-gold text-dark px-6 py-2.5 hover:bg-gold-light transition-all duration-300"
            >
              {t.nav.book}
            </a>
          </div>

          <button
            className="md:hidden text-white"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-dark-secondary border-t border-gold/20">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMenuOpen(false)}
                className="block text-sm font-montserrat tracking-widest uppercase text-white/80 hover:text-gold py-2"
              >
                {link.label}
              </Link>
            ))}
            <div className="flex space-x-2 pt-2 border-t border-gold/20">
              {languages.map((l) => (
                <button
                  key={l.code}
                  onClick={() => { handleLangChange(l.code); setMenuOpen(false); }}
                  className={`text-xs px-3 py-2 border ${
                    lang === l.code ? 'border-gold text-gold' : 'border-gold/30 text-white/60'
                  }`}
                >
                  {l.label}
                </button>
              ))}
            </div>
            <a
              href="#contact"
              onClick={() => setMenuOpen(false)}
              className="block text-center text-sm font-montserrat tracking-widest uppercase bg-gold text-dark px-6 py-3 mt-2"
            >
              {t.nav.book}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
